/**
 * The slot registrations of `web/when` (1.O-1 deliverables 8 and 17): the When pill
 * (`header.pills.when`, order 50) and the Chronology tab (`rail.tabs.chronology`, order 50, after
 * the Cast tab's 40). `apps/web/src/editor-services/slots.ts` collects them as
 * `SLOT_MODULES['web/when']`.
 */
import type { SlotComponentProps, SlotRegistration, WorkPackageId } from '@codex/contracts';
import { createElement, lazy, Suspense } from 'react';

/**
 * Loaded on first use: the pill reads the calendar engine and the editor package, which the slot
 * collector and its specs need not evaluate. The pills row has no `Suspense` of its own, so the
 * pill brings one (nothing shows while it loads).
 */
const LazyPill = lazy(() =>
  import('./when-pill.js').then((module) => ({ default: module.WhenPill })),
);

export function WhenPillSlot(props: SlotComponentProps) {
  return createElement(Suspense, { fallback: null }, createElement(LazyPill, props));
}

/** Loaded on first use, as the pill; the rail shows each tab inside its own `Suspense`. */
export const ChronologyTabSlot = lazy(() =>
  import('./chronology-tab.js').then((module) => ({ default: module.ChronologyTab })),
);

export const owner: WorkPackageId = '1.O-1';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 50, owner: '1.O-1', component: WhenPillSlot },
  { slot: 'rail.tabs', order: 50, owner: '1.O-1', component: ChronologyTabSlot },
];
